import { Dialog, styled } from "common/components";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  position: "absolute",
  bottom: "0px",
  maxWidth: "800px",
}));
